import { pleaseConfirm } from "../utils/common";
var VARIANTS = {
  ARHI: "if you would like to add any dependants to your cover"
};
var validDependantsGroupOption = function validDependantsGroupOption(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var error; // eslint-disable-line init-declarations
  if (!value) {
    error = pleaseConfirm(VARIANTS[funnel] || VARIANTS.ARHI);
  }
  return error;
};
export default validDependantsGroupOption;